<template> 
  <section>
    <navbar-dashboard name="Editar contenido"></navbar-dashboard>
    <section class="ew-smaller-container">
      <div class="ew-card">
        <p class="ew-hint">
          Al proveer esta información nos ayudas a ofrecerte un mejor servicio. Por ejemplo, en caso de extravío esta información ayuda al proveedor a localizar más pronto tu paquete.
        </p>

        <form class="ew-form" @submit.prevent="updateShipment">
          <div class="ew-form__field">
            <label class="ew-label" for="esd-description">Descripción del contenido</label>
            <input id="esd-description" type="text" maxlength="35" class="ew-input ew-input--block" v-model="description_of_the_content" required>
          </div>

          <div class="ew-form__actions">
            <router-link class="ew-btn-outline" :to="'/shipments/' + $route.params['id']">Cancelar</router-link>
            <button class="ew-btn-primary" type="submit">Aplicar cambios</button>
          </div>
        </form>
      </div>
    </section>
  </section>
</template>

<script>
import axios from 'axios'
import commons from '../../commons'
import api from '../../commons/api'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Navbar from '../Header/Navbar'

export default {
  name: 'EditShipmentDestination',
  data () {
    return {
      step: 1,

      selectedShippingOptionIndex: -1,

      origin_direction: {
        full_name: '',
        email: '',
        phone: '',
        address: '',
        reference_of_origin: '',
        colony: '',
        postal_code: '',
        state_code: '',
        city: '',
        country_code: 'MX'
      },

      destination_direction: {
        full_name: '',
        email: '',
        phone: '',
        address: '',
        reference_of_origin: '',
        colony: '',
        postal_code: '',
        state_code: '',
        city: '',
        country_code: 'MX'
      },

      description_of_the_content: '',
      package_insurance: false,

      insurance_information: {
        package_value: null,
        responsible_for_the_package: null,
        mail_responsible: null,
        cost: null
      },

      parcels: [
        {
          depth: '',
          width: '',
          height: '',
          weight: ''
        }
      ],

      requestBody: {
        origin_direction: {
          country_code: '',
          postal_code: '',
          city: '',
          suburb: ''
        },

        parcels: [
          {
            weight: '',
            height: '',
            depth: '',
            width: ''
          }
        ],
        destination_direction: {
          country_code: '',
          postal_code: '',
          city: '',
          suburb: ''
        },
        insured_value: '',
        insured_value_currency: 'MXN'
      }
    }
  },
  methods: {
    addParcel () {
      this.parcels.push({
        depth: '',
        width: '',
        height: '',
        weight: ''
      })
    },
    removeParcel (index) {
      if (this.parcels.length > 1) {
        this.parcels.splice(index, 1)
        console.log(this.parcels)
      }
    },
    nextStep () {
      if (this.currentStep < 6) {
        this.step++
      }
    },
    prevStep () {
      if (this.currentStep > 1) {
        this.step--
      }
    },

    calculateQuote () {
      console.log('calculateQuote')

      this.requestBody.parcels = this.parcels

      this.requestBody.origin_direction = {
        country_code: this.origin_direction.country_code,
        postal_code: this.origin_direction.postal_code,
        city: this.origin_direction.city,
        suburb: this.origin_direction.colony
      }

      this.requestBody.destination_direction = {
        country_code: this.destination_direction.country_code,
        postal_code: this.destination_direction.postal_code,
        city: this.destination_direction.city,
        suburb: this.destination_direction.colony
      }

      if (this.package_insurance) {
        this.insured_value = this.insurance_information.cost
      } else {
        delete this.insured_value
      }

      this.setQuotingRequestBody(this.requestBody)

      this.quoting()
        .then(() => {
          this.nextStep()
        })
        .catch(error => console.log(error))
    },

    updateShipment () {
      this.setSelectedShippingOption(
        this.shippingOptions[this.selectedShippingOptionIndex]
      )

      const requestBody = {
        description_of_the_content: this.description_of_the_content
      }

      this.setNewShipmentRequestBody(requestBody)
      api.shipment.update(this.$route.params['id'], requestBody).then(() => {
        this.getAllShipments()
        this.$router.go(-1)
      })
    },

    checkAddressOrigin (event) {
      // console.log(event)
      const query = event.target.value
      if (query.length >= 3) {
        this.getLocationInfo(query, 'MX').then(response => {
          console.log(response.data)
          this.origin_direction.city =
            response.data[0].parish + ', ' + response.data[0].state
        })
      }
    },
    checkAddressDestination (event) {
      // console.log(event)
      const query = event.target.value
      if (query.length >= 3) {
        this.getLocationInfo(query, 'MX').then(response => {
          // console.log(response.data)
          this.destination_direction.city =
            response.data[0].parish + ', ' + response.data[0].state
        })
      }
    },
    getLocationInfo (zipCode, countryCode) {
      return axios.get(
        `${
          commons.apiURL
        }/api/v1/postalcode?zipCode=${zipCode}&country=${countryCode}`
      )
    },
    ...mapMutations([
      'netNewShipmentRequestBody',
      'setQuotingRequestBody',
      'setSelectedShippingOption',
      'setNewShipmentRequestBody'
    ]),
    ...mapActions(['quoting', 'newShipment', 'getAllShipments'])
  },
  computed: {
    currentStep () {
      return this.step
    },
    ...mapGetters([
      'quotingRequestBody',
      'selectedShippingOption',
      'serviceProviders',
      'shippingOptions'
    ])
  },
  created () {
    api.shipment.getByID(this.$route.params['id']).then(response => {
      this.description_of_the_content =
        response.data.description_of_the_content
    })
  },
  components: {
    'navbar-dashboard': Navbar
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/app-tokens";
@import "../../assets/styles/ew-components";

.ew-smaller-container { @include app-tokens; max-width: 600px; margin: 2.5rem auto; padding: 0 1rem 4rem; }
.ew-card { @include ew-card; padding: 1.5rem 1.75rem; }
.ew-form { max-width: none; }
.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; margin-bottom: 1.25rem; }
.ew-form__actions { display: flex; justify-content: flex-end; gap: 0.6rem; }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input { @include ew-input; }
.ew-input--block { width: 100%; }
.ew-hint { font-family: var(--app-font); color: var(--app-navy-secondary); font-size: 0.9rem; margin-bottom: 1.25rem; }
</style>



// WEBPACK FOOTER //
// src/components/editShipment/EditShipmentDescription.vue